import React from 'react';

import AddPersonIcon from 'icons/addperson-xl.svg';
import PersonIcon from 'icons/person.svg';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import OutlinedButton from 'components/application/buttons/OutlinedButton';

import { useCurrentActor } from 'components/contexts/CurrentActor';
import { useProjectPersonnelContext } from 'components/projectPersonnel/contexts/ProjectPersonnelContext';

export default function ProjectPersonnelBlankNotice({
  onAssignPersonnelClick,
}) {
  const {
    division: {
      attributes: { singularRAMSName },
    },
  } = useCurrentActor();

  const { projectPersonnelPolicy } = useProjectPersonnelContext();

  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'projectPersonnel.components.ProjectPersonnelBlankNotice',
  });

  const { t: i18nTCommon } = useTranslation('common');

  return (
    <section className='section section--notice section--notice--no-top-border-radius tw-border-grey-100 tw-bg-white'>
      <AddPersonIcon
        className='-tw-mb-2 [&_path]:tw-fill-grey-500'
        height={64}
        width={64}
      />
      <h2 className='section__header tw-text-l tw-font-semibold tw-text-grey-900'>
        {i18nTCommon(
          projectPersonnelPolicy.canCreate ?
            'personnel.addOrAssignPersonnel'
          : 'personnel.noPersonnel',
        )}
      </h2>
      <p className='section__content'>
        {projectPersonnelPolicy.canCreate ?
          i18nT('addOrAssignPersonnel', {
            interpolation: { escapeValue: false },
            singularRAMSName,
          })
        : i18nTCommon('projects.noPersonnelAssigned', {
            interpolation: { escapeValue: false },
            singularRAMSName,
          })
        }
      </p>
      {projectPersonnelPolicy.canCreate && (
        <OutlinedButton color='grey' onClick={onAssignPersonnelClick} size='sm'>
          <div className='tw-flex tw-items-center tw-gap-1'>
            <PersonIcon className='-tw-ml-2' height={24} width={24} />
            {i18nTCommon('personnel.addAssignPersonnel')}
          </div>
        </OutlinedButton>
      )}
    </section>
  );
}

ProjectPersonnelBlankNotice.propTypes = {
  onAssignPersonnelClick: PropTypes.func.isRequired,
};
